import React from "react"
import { useStaticQuery, graphql } from "gatsby"
// import "../style/style.css"
import { Link } from "gatsby"

const BeiAllenReisenInkludiert = (props) => {
  const data = useStaticQuery(graphql`
    {
      contentfulBeiAllenReisenInkludiert(
        id: { eq: "f4459c05-e92f-52f9-baf7-1f6a63dc7f06" }
      ) {
        title
        bulletPoints {
          title
          icon {
            description
            file {
              url
            }
          }
          text {
            id
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  `)
  const bullets = data.contentfulBeiAllenReisenInkludiert.bulletPoints.map(
    (bulletPoint, index) => (
      <div key={index} className="bei-allen-reisen-inkludiert-bullet">
        <div className="bei-allen-reisen-inkludiert-bullet-pic">
          <img
            alt={bulletPoint.icon.description}
            src={bulletPoint.icon.file.url}
          />
        </div>
        <div className="bei-allen-reisen-inkludiert-bullet-text">
          <div className="bei-allen-reisen-inkludiert-bullet-text-headline">
            {bulletPoint.title}
          </div>
          <div
            className="bei-allen-reisen-inkludiert-bullet-text-text"
            dangerouslySetInnerHTML={{
              __html: bulletPoint.text.childMarkdownRemark.html,
            }}
          ></div>
        </div>
      </div>
    )
  )
  return (
    <div className="bei-allen-reisen-inkludiert">
      <div className="bei-allen-reisen-inkludiert-inhalte">{bullets}</div>
      <h1 className="bei-allen-reisen-inkludiert-headline">
        Bei allen Reisen inkludiert
      </h1>
      <div className="buttons">
        <div className="buchen-button-big">
          <Link
            to="/ueber-uns"
            className="buchen-button-big-link buchen-button-big-link"
          >
            Kontakt
          </Link>
        </div>
        {props.buchenMoeglich && (
          <div className="buchen-button-big">
            <button
              className={
                "w-full buchen-button-big-link buchen-button-big-link-" +
                props.typ
              }
              onClick={props.openModal}
            >
              Buchungsanfrage
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default BeiAllenReisenInkludiert
